import React from 'react';

class Marker extends React.Component{
    updateMap = ()=>{
        let props = this.props,
            apiname = props.apiname,
            lat = props.lat,
            lng = props.lng;

        let AMap = window.AMap;
        if (AMap.Map) {
            let map = new AMap.Map('locationMarker' + apiname, {
                dragEnable: false,
                zoomEnable: false,
                resizeEnable: false,
                doubleClickZoom: false,
                touchZoom: false,
                center: [lng || 116.397428 , lat || 39.9092],
                zoom: 13
            });
            if (lat && lng){
                new AMap.Marker({
                    position: new AMap.LngLat(lng, lat),
                    zIndex: 200,
                    map: map
                });
            }
        };
    }
    componentDidMount(){
        this.updateMap();
    }
    shouldComponentUpdate(nextProps, nextState){
        let props = this.props;
        return nextProps.lat !==props.lat || nextProps.lng !== props.lng;
    }
    componentDidUpdate(){
        this.updateMap();
    }
    render() {
        let apiname = this.props.apiname;

        return (<div className="location__map"><div className="locationMarker" id={'locationMarker' + apiname}></div></div>);
    }
}
export default Marker;


// WEBPACK FOOTER //
// ./src/component/Location/Marker.js